import _classCallCheck from "/home/runner/work/gear/gear/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/gear/gear/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/gear/gear/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/gear/gear/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/gear/gear/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/home/runner/work/gear/gear/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";

/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
import { serialization } from '@tensorflow/tfjs-core';
import { getUid } from '../backend/state';
import { ValueError } from '../errors';
import { Layer, Node, SymbolicTensor } from './topology';
export var InputLayer = /*#__PURE__*/function (_Layer) {
  _inherits(InputLayer, _Layer);

  function InputLayer(args) {
    var _this;

    _classCallCheck(this, InputLayer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InputLayer).call(this, {
      dtype: args.dtype,
      name: args.name != null ? args.name : getUid('input').toString()
    })); // Normalize config.batchSize and config.sparse

    if (args.batchSize == null) {
      args.batchSize = null;
    }

    if (args.sparse == null) {
      args.sparse = false;
    }

    _this.trainable = false;
    _this.built = true;
    _this.sparse = args.sparse;

    if (args.inputShape != null && args.batchInputShape != null) {
      throw new ValueError('Only provide the inputShape OR ' + 'batchInputShape argument to inputLayer, not both at the same time.');
    }

    var batchInputShape = args.batchInputShape;

    if (batchInputShape == null) {
      if (args.inputShape == null) {
        throw new ValueError('An InputLayer should be passed either a ' + '`batchInputShape` or an `inputShape`.');
      } else {
        batchInputShape = [args.batchSize].concat(args.inputShape);
      }
    } else {
      // TODO(michaelterry): Backport to PyKeras
      if (args.batchSize != null) {
        throw new ValueError('Cannot specify batchSize if batchInputShape is ' + 'specified when creating an InputLayer.');
      }
    }

    var dtype = args.dtype || 'float32';
    _this.batchInputShape = batchInputShape;
    _this.dtype = dtype; // TODO(michaelterry): Backport this to PyKeras?

    _this.inputSpec = [{
      shape: batchInputShape
    }];
    var inputTensor = new SymbolicTensor(_this.dtype, _this.batchInputShape, _assertThisInitialized(_assertThisInitialized(_this)), [], {}, _this.name);
    inputTensor.nodeIndex = 0;
    inputTensor.tensorIndex = 0; // Create an input node to add to this.outboundNode.
    // (This call has side effects.)
    // tslint:disable-next-line:no-unused-expression

    new Node({
      outboundLayer: _assertThisInitialized(_assertThisInitialized(_this)),
      inboundLayers: [],
      nodeIndices: [],
      tensorIndices: [],
      inputTensors: [inputTensor],
      outputTensors: [inputTensor],
      inputMasks: [null],
      outputMasks: [null],
      inputShapes: [batchInputShape],
      outputShapes: [batchInputShape]
    });
    return _this;
  }

  _createClass(InputLayer, [{
    key: "apply",
    value: function apply(inputs, kwargs) {
      throw new ValueError('Cannot pass any input to an ' + "InputLayer's apply() method. InputLayer name: ".concat(this.name));
    }
  }, {
    key: "dispose",
    value: function dispose() {
      // dispose() for InputLayer is overridden as no-op.
      return {
        refCountAfterDispose: this._refCount,
        numDisposedVariables: 0
      };
    }
  }, {
    key: "getConfig",
    value: function getConfig() {
      return {
        batchInputShape: this.batchInputShape,
        dtype: this.dtype,
        sparse: this.sparse,
        name: this.name
      };
    }
  }]);

  return InputLayer;
}(Layer);
/** @nocollapse */

InputLayer.className = 'InputLayer';
serialization.registerClass(InputLayer);
export function Input(config) {
  if (config.batchShape == null && config.shape == null) {
    throw new Error('Please provide to Input either a `shape`' + ' or a `batchShape` argument. Note that ' + '`shape` does not include the batch ' + 'dimension.');
  }

  if (config.batchShape != null && config.shape != null) {
    // TODO(michaelterry): Backport to PyKeras.
    throw new ValueError('Please provide either a `shape` or `batchShape` ' + 'argument to Input, but not both.');
  }

  var batchShape = config.batchShape;

  if (config.shape != null && batchShape == null) {
    batchShape = [null].concat(config.shape);
  }

  var dtype = config.dtype;

  if (dtype == null) {
    dtype = 'float32';
  }

  var inputLayer = new InputLayer({
    batchInputShape: batchShape,
    name: config.name,
    dtype: dtype,
    sparse: config.sparse
  });
  var outputs = inputLayer.inboundNodes[0].outputTensors;
  return outputs[0];
}